export { default } from "@features/investments/screens/coverage-screen";
